module.exports = __webpack_public_path__ + "img/type1.e5c853f6.jpg";